<template>
  <div>
    <div>
      <!-- 面包屑导航区域 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{path: '/home'}">首页</el-breadcrumb-item>
        <el-breadcrumb-item>报警管理</el-breadcrumb-item>
        <el-breadcrumb-item>报警设置列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card>
      <!-- 报警设置信息表格 -->
      <el-button
        icon="el-icon-download"
        plain
        @click="getpdfyes"
        type="warning"
        size="mini"
      >导出</el-button>
      <div class="test555">
        <el-table id="pdfDom" :data="AlarmSetList">
          <el-table-column type="index" label="序号" align="center"></el-table-column>
          <el-table-column label="报警内容" prop="AlarmContent" align="center"></el-table-column>
          <el-table-column label="监控变量" prop="Variable_Maintenance_ID" width="120px" align="center"></el-table-column>
          <el-table-column label="触发报警类型" prop="AlarmType" width="160px" align="center"></el-table-column>
          <el-table-column label="X值" prop="X_Value" width="100%" align="center"></el-table-column>
          <el-table-column label="Y值" prop="Y_Value" width="100%" align="center"></el-table-column>
          <el-table-column label="创建时间" prop="CreateTimeConvert" width="170px" align="center">
            <template slot-scope="scope">
              {{ scope.row.CreateTimeConvert }}
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="Remark" width="180px" align="center"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-edit" size="mini" @click="showEditDialog(scope)">编辑</el-button>
              <el-button type="text" icon="el-icon-delete" size="mini" @click="removeSet(scope)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>

    <!-- 编辑产品信息的会话框 -->
    <el-dialog title="修改报警设置" :visible.sync="editDialogVisible" width="30%" @close="editDialogClose">
      <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="120px">
        <el-form-item label="报警内容" prop="AlarmContent" required>
          <el-input v-model="editForm.AlarmContent" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="监控变量" prop="Variable_Maintenance_ID" required>
          <el-select v-model="editForm.Variable_Maintenance_ID" placeholder="请变量设置">
            <el-option v-for="(_, p) in VariableList" :key="p" :label="p" :value="p">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="产品类型" prop="TypeName">
          <el-select v-model="addForm.TypeName" placeholder="请选择产品类型">
            <el-option v-for="item in goodslist" :key="item.ID" :label="item.TypeName" :value="item.TypeName">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="触发报警类型" prop="AlarmType" required>
          <el-select v-model="editForm.AlarmType" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <div
          v-if="
            editForm.AlarmType === '0' ||
            editForm.AlarmType === '1' ||
            editForm.AlarmType === '2' ||
            editForm.AlarmType === '3' ||
            editForm.AlarmType === '4'
          "
        >
          <el-form-item label="X值" prop="X_Value" required>
            <el-input v-model="editForm.X_Value" style="width: 90%" size="medium"></el-input>
          </el-form-item>
        </div>
        <div v-if="editForm.AlarmType === '2' || editForm.AlarmType === '3'">
          <el-form-item label="Y值" prop="Y_Value" required>
            <el-input v-model="editForm.Y_Value" style="width: 90%" size="medium"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="备注" prop="Remark">
          <el-input v-model="editForm.Remark" style="width: 90%" size="medium"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="editDialogVisible = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="editAlarmSet">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
    data () {
        return {
            getTypeList: {
                page: '1',
                limit: '10',
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms',
                tableName: 'Main_Alarm'
            },
            // 查询参数对象
            queryInfo: {
                query: '',
                pagenum: 1,
                pagesize: 10
            },
            // 报警设置列表
            AlarmSetList: [],
            // 变量表
            VariableList: [],
            // 总数据条数
            total: 0,
            // 控制修改信息对话框的显示与隐藏
            editDialogVisible: false,
            // 编辑用户信息的表单
            editForm: {},
            // 修改表单的验证规则对象
            editFormRules: {
                VariableName: [
                    { required: true, message: '请输入变量名称', trigger: 'blur' }
                ],
                VariableCode: [
                    { required: true, message: '请输入变量代码', trigger: 'blur' },
                ],
                CreateTime: [
                    { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
                ],
                Is_Alarm: [
                    { required: true, message: '请输入是否报警', trigger: 'blur' }
                ],
                StartAddress: [
                    { required: true, message: '请输入起始地址', trigger: 'blur' }
                ],
                Read_QTY: [
                    { required: true, message: '请输入读取数量', trigger: 'blur' },
                ],
                OperationType: [
                    { required: true, message: '请输入操作类型', trigger: 'blur' }
                ],
                DecimalPrecision: [
                    { required: true, message: '请输入小数精度', trigger: 'blur' }
                ]
            },
            // 触发报警类型
            options: [{
                value: '0',
                label: '大于X值'
            }, {
                value: '1',
                label: '小于X值'
            }, {
                value: '2',
                label: '大于X值且小于Y值'
            }, {
                value: '3',
                label: '大于Y值且小于X值'
            }, {
                value: '4',
                label: '等于X值'
            }],
        }
    },
    created () {
        this.getAlarmSetList()
        this.getVariableList()
    },
    methods: {
        // 调用接口查询报警设置信息
        async getAlarmSetList () {
            const { data: res } = await this.$http.get('/WMS/queryMainAlarm', { params: this.getTypeList })
            console.log(res.data)
            for (var i = 0; i < res.data.length; i++) {
                if (res.data[i].AlarmType == '0') {
                    res.data[i].AlarmType = '大于X值'
                }
                if (res.data[i].AlarmType == '1') {
                    res.data[i].AlarmType = '小于X值'
                }
                if (res.data[i].AlarmType == '2') {
                    res.data[i].AlarmType = '大于X值且小于Y值'
                }
                if (res.data[i].AlarmType == '3') {
                    res.data[i].AlarmType = '大于Y值且小于X值'
                }
                if (res.data[i].AlarmType == '4') {
                    res.data[i].AlarmType = '等于X值'
                }
            }
            this.AlarmSetList = res.data
        },
        // 调用接口删除变量
        async removeSet (scope) {
            const confirmResult = await this.$confirm(
                '此操作将永久删除该变量信息, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err)

            if (confirmResult !== 'confirm') {
                return this.$message.info('已经取消删除！')
            }

            let params = new URLSearchParams();
            params.append("ID", scope.row.ID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            const { data: res } = await this.$http.post('/WMS/deleteMainAlarm', params)
            console.log(res)
            if (res !== 1) {
                return this.$message.error('删除失败')
            }
            this.$message.success('删除成功！')
            this.getAlarmSetList()
        },
        // 展示修改变量的对话框
        async showEditDialog (scope) {
            this.editDialogVisible = true
            let params = new URLSearchParams();
            params.append("ID", scope.row.ID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            params.append("tableName", this.getTypeList.tableName)
            // const { data: res } = await this.$http.get('/queryMainAlarmID', { params })
            const { data: res } = await this.$http.get('/WMS/GeneralQueryID', { params })
            console.log(res.data)
            this.editForm = res.data[0]
            console.log(this.editForm)
        },
        // 监听修改信息对话框的关闭事件
        editDialogClose () {
            this.$refs.editFormRef.resetFields()
        },
        //  监听添加信息对话框的关闭事件
        addDialogClosed () {
            this.$refs.addFormRef.resetFields()
        },
        // 调用接口编辑报警设置信息
        editAlarmSet () {
            this.$refs.editFormRef.validate(async valid => {
                if (!valid) return
                let params = new URLSearchParams();
                params.append("privateKey", this.getTypeList.privateKey)
                params.append("appIdentification", this.getTypeList.appIdentification)
                params.append("Variable_Maintenance_ID", this.editForm.Variable_Maintenance_ID)
                params.append("AlarmContent", this.editForm.AlarmContent)
                params.append("AlarmType", this.editForm.AlarmType)
                params.append("X_Value", this.editForm.X_Value)
                params.append("Y_Value", this.editForm.Y_Value)
                params.append("Remark", this.editForm.Remark)
                params.append("CreateTime", this.editForm.CreateTime)
                params.append("ID", this.editForm.ID)
                const { data: res } = await this.$http.post('/WMS/updateMainAlarm', params)
                console.log('12423' + res)
                if (res !== 1) {
                    this.$message.error('修改报警设置信息失败！')
                }
                // 关闭对话框
                this.editDialogVisible = false
                // 刷新数据列表
                this.getAlarmSetList()
                // 提示修改成功
                this.$message.success('修改报警设置信息成功！')
            })
        },
        // 调用接口获取变量维护信息
        async getVariableList () {
            // console.log(123)
            const { data: res } = await this.$http.get('/WMS/alertNum')
            this.VariableList = res.data || {}
        },
        getpdfyes () {
            this.getPdf()
        }
    }
}
</script>

<style lang="less" scoped>
.test555 {
  margin-top: 25px;
}
</style>
